import React from 'react';

const viewports = [
  {
    name: 'Mobile (sm)',
    width: 390,
    height: 844,
    description: 'Small devices',
    frame: 'rounded-[40px] bg-black p-3',
    browserBar: 'h-12 bg-white border-b',
  },
  {
    name: 'Tablet (md)',
    width: 768,
    height: 1024,
    description: 'Medium devices',
    frame: 'rounded-[20px] bg-black p-3',
    browserBar: 'h-12 bg-white border-b',
  },
  {
    name: 'Tablet Landscape (lg)',
    width: 1024,
    height: 768,
    description: 'Large devices',
    frame: 'rounded-[20px] bg-black p-3',
    browserBar: 'h-12 bg-white border-b',
  },
  {
    name: 'Desktop (xl)',
    width: 1280,
    height: 960,
    description: 'Extra large devices',
    frame: 'rounded-lg bg-[#1D1D1F]',
    browserBar: 'h-[88px] bg-white border-b flex flex-col',
  },
];

const ResponsivePreview: React.FC = () => {
  const currentUrl = window.location.href.replace('/responsive-preview', '');

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="mx-auto max-w-[1800px]">
        <h1 className="mb-8 text-3xl font-medium text-gray-900">Responsive Preview</h1>
        <div className="grid grid-cols-1 gap-8 xl:grid-cols-2">
          {viewports.map((viewport) => {
            const containerWidth = 800;
            const containerHeight = 800;
            const scaleWidth = containerWidth / viewport.width;
            const scaleHeight = containerHeight / viewport.height;
            const scale = Math.min(scaleWidth, scaleHeight);

            return (
              <div
                key={viewport.name}
                className="overflow-hidden rounded-lg border bg-white p-6 shadow-lg"
              >
                <div className="mb-4">
                  <h2 className="text-xl font-medium text-gray-700">{viewport.name}</h2>
                  <p className="text-sm text-gray-500">{viewport.description}</p>
                </div>
                <div
                  className={`mx-auto overflow-hidden ${viewport.frame}`}
                  style={{
                    width: viewport.width * scale,
                    height: viewport.height * scale,
                  }}
                >
                  {/* macOS window controls */}
                  <div className="flex h-8 items-center bg-[#2D2D2D] px-3">
                    <div className="flex space-x-1.5">
                      <div className="size-3 rounded-full bg-[#FF5F57]"></div>
                      <div className="size-3 rounded-full bg-[#FEBC2E]"></div>
                      <div className="size-3 rounded-full bg-[#28C840]"></div>
                    </div>
                    {viewport.name.includes('Desktop') && (
                      <div className="ml-4 flex items-center space-x-4">
                        <div className="h-3 w-16 rounded-sm bg-[#404040]"></div>
                        <div className="h-3 w-16 rounded-sm bg-[#404040]"></div>
                        <div className="h-3 w-16 rounded-sm bg-[#404040]"></div>
                      </div>
                    )}
                  </div>
                  <div className="overflow-hidden bg-white">
                    {/* Browser UI for each device */}
                    <div className={viewport.browserBar}>
                      {viewport.name.includes('Desktop') && (
                        <>
                          <div className="flex h-10 items-center border-b px-4">
                            <div className="flex space-x-2">
                              <div className="size-6 rounded-full bg-gray-100"></div>
                              <div className="size-6 rounded-full bg-gray-100"></div>
                              <div className="size-6 rounded-full bg-gray-100"></div>
                            </div>
                          </div>
                          <div className="flex h-[48px] items-center px-4">
                            <div className="h-8 w-full rounded-full bg-gray-100"></div>
                          </div>
                        </>
                      )}
                      {!viewport.name.includes('Desktop') && (
                        <div className="flex h-full items-center justify-between px-4">
                          <div className="size-4 rounded-full bg-gray-100"></div>
                          <div className="h-7 w-3/5 rounded-lg bg-gray-100"></div>
                          <div className="size-4 rounded-full bg-gray-100"></div>
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        width: viewport.width,
                        height: viewport.height - (viewport.name.includes('Desktop') ? 88 : 48),
                        transform: `scale(${scale})`,
                        transformOrigin: '0 0',
                      }}
                    >
                      <iframe
                        src={currentUrl}
                        title={`${viewport.name} Preview`}
                        style={{
                          width: '100%',
                          height: '100%',
                        }}
                        className="border-0"
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ResponsivePreview;
